import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { RoutePrivate } from './RoutePrivate';
import Error from '../pages/error/error.container';
import Login from '../pages/login/login.container';
import GraficosMain from '../pages/graficos/graficos.container';
import MainCommon from '../pages/main/main.common.container';
import Histologia from '../pages/histologia/histologia.container';
import Configuracao from '../pages/configuracao/configuracao.container';
import ControleTarefas from '../pages/controleTarefas/controle-tarefas.container';
import Citologia from '../pages/citologia/citologia.container';
import Imunologia from '../pages/imunologia/imunologia.container';
import Descarte from '../pages/descarte/descarte.container';
import Arquivamento from '../pages/arquivamento/arquivamento.container';
import Relatorios from '../pages/relatorio/relatorio.container';
import SolicitacoesContainer from '../pages/solicitacao/solicitacao.container';
import Laudo from '../pages/laudo/laudo.container';
import { rotaEnum } from '@common/util/defaultValues';
import TarefasPage from '../pages/tarefas/tarefas.page';
import { homepage } from '@constants/defaultValues';

function Routes () {
  useEffect(() => {
    if (!window.location.pathname.includes(homepage)) {
      window.history.replaceState('', '', homepage + window.location.pathname);
    }
  }, []);
  return (
    <Switch>
      <Route exact path={`/${rotaEnum.ERROR}`} component={Error} />
      <Route exact path={`/${rotaEnum.ERROR}/:title`}  component={Error} />
      <Route exact path={`/${rotaEnum.ERROR}/:title/:desc`}  component={Error} />
      <Route exact path={`/${rotaEnum.ERROR}/:title/:desc/:code`}  component={Error} />
      <Route exact path={`/${rotaEnum.ERROR}/:title/:desc/:code/:origin/`}  component={Error} />
      <Route exact path={`/${rotaEnum.LOGIN}`}  component={Login} />
      <Route exact path={`/${rotaEnum.LOGIN}/:msn`}  component={Login} />
      <RoutePrivate exact path={`${rotaEnum.HOME}`}  component={MainCommon} />
      <RoutePrivate exact path={`/${rotaEnum.LAUDO}/:cdlaudo`}  component={Laudo} />
      <RoutePrivate exact path={`/${rotaEnum.GRAFICOS}`}  component={GraficosMain} />
      <RoutePrivate exact path={`/${rotaEnum.HISTOLOGIA}`}  component={Histologia} />
      <RoutePrivate exact path={`/${rotaEnum.CONTROLETAREFAS}`} component={ControleTarefas} />
      <RoutePrivate exact path={`/${rotaEnum.CONFIG}`}  component={Configuracao} />
      <RoutePrivate exact path={`/${rotaEnum.CITOLOGIA}`}  component={Citologia} />
      <RoutePrivate exact path={`/${rotaEnum.IMUNOLOGIA}`}  component={Imunologia} />
      <RoutePrivate exact path={`/${rotaEnum.TAREFASMEDICO}`}  component={TarefasPage} />
      <RoutePrivate exact path={`/${rotaEnum.DESCARTE}`}  component={Descarte} />
      <RoutePrivate exact path={`/${rotaEnum.ARQUIVAMENTO}`}  component={Arquivamento} />
      <RoutePrivate exact path={`/${rotaEnum.RELATORIOS}`}  component={Relatorios} />
      <RoutePrivate exact path={`/${rotaEnum.SOLICITACOES}`}  component={SolicitacoesContainer} />
    </Switch>
  );
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js